const KEY_PREFIX_V1 = 'welya-live-admin-pdf-page:';

function storageKey(sessionId: number, slideId: number): string {
  return `${KEY_PREFIX_V1}${sessionId}:${slideId}`;
}

export function clearStoredAdminPdfPagesForSession(sessionId: number): void {
  try {
    const prefix = `${KEY_PREFIX_V1}${sessionId}:`;
    const toRemove: string[] = [];
    const len = globalThis.localStorage?.length ?? 0;
    for (let i = 0; i < len; i++) {
      const k = globalThis.localStorage.key(i);
      if (k?.startsWith(prefix)) {
        toRemove.push(k);
      }
    }
    for (const k of toRemove) {
      globalThis.localStorage.removeItem(k);
    }
  } catch {
    console.error('Error clearing stored admin PDF pages for session', sessionId);
  }
}

export function getStoredAdminPdfPage(sessionId: number, slideId: number): number | undefined {
  try {
    const raw = globalThis.localStorage?.getItem(storageKey(sessionId, slideId));
    if (raw == null) return undefined;
    const n = Number.parseInt(raw, 10);
    if (!Number.isFinite(n) || n < 1) return undefined;
    return n;
  } catch {
    return undefined;
  }
}

export function setStoredAdminPdfPage(sessionId: number, slideId: number, page: number): void {
  try {
    if (!Number.isFinite(page) || page < 1) return;
    globalThis.localStorage?.setItem(storageKey(sessionId, slideId), String(Math.floor(page)));
  } catch {
    console.error('Error setting stored admin PDF page', sessionId, slideId, page);
  }
}
